import {z} from 'zod';
import ajaxService from '../../../services/ajaxService';
import FormErrorHandler from './FormErrorHandler';

class RequestPasswordResetForm {
	#form;
	#loginForm;
	/** @type {FormErrorHandler} */ #formErrorHandler;
	#xhrInProgress = false;
	
	/**
	 * @param {Element} form
	 * @param {Element} loginForm
	 */
	constructor(form, loginForm) {
		this.#form = form;
		this.#loginForm = loginForm;
		this.#formErrorHandler = new FormErrorHandler(this.#form);
		
		this.#initEvents();
	}
	
	#initEvents() {
		this.#form.addEventListener('submit', (ev) => {
			ev.preventDefault();
			this.#submitForm();
		});
		this.#form.parentElement.querySelector('.successfulPasswordResetMessageContainer .switchToTheLoginForm').addEventListener('click', (ev) => {
			ev.preventDefault();
			this.#switchToTheLoginForm();
		});
	}
	
	#submitForm() {
		if (!this.#isCurrentEmailValid() || this.#xhrInProgress) {
			return;
		}
		
		this.#xhrInProgress = true;
		this.#getElement('.submitButton').classList.add('disabled');
		
		this.#sendRequest()
		    .catch((err) => {
			    this.#getElement('.unknownErrorMessage').classList.remove('hidden-element');
			    console.error('sendRequest failed:', err);
		    });
	}

	#switchToTheLoginForm() {
		$(this.#form.parentElement).find('.successfulPasswordResetMessageContainer').slideUp(
			300,
			() => {
				$(this.#loginForm).slideDown(300);
			}
		);
	}
	
	async #sendRequest() {
		const result = await ajaxService.sendPost({
			'url' : 'user/request-password-reset',
			'data': {
				'email': this.#getUserEmail()
			}
		});
		
		this.#handleResponse(result);
	}
	
	#handleResponse({response, xhr}) {
		const responseObject = typeof xhr === 'object' ? xhr : response;
		
		responseObject
			.then(() => {
				const $form = $(this.#form);

				$form.slideUp(
					300,
					() => {
						$form.parent().find('.successfulPasswordResetMessageContainer').slideDown(500);
					}
				);
			})
			.always(() => {
				this.#xhrInProgress = false;
				this.#getElement('.submitButton').classList.remove('disabled');
			})
			.catch(() => {
				this.#formErrorHandler.handleErrorResponse(responseObject);
			});
	}
	
	/**
	 * @param {string} selector
	 * @returns {Element | HTMLInputElement}
	 */
	#getElement(selector) {
		return this.#form.querySelector(selector);
	}
	
	#isCurrentEmailValid() {
		return z.string().email().safeParse(this.#getUserEmail()).success;
	}
	
	#getUserEmail() {
		return this.#getElement('.emailInput').value;
	}
	
}

export default RequestPasswordResetForm;